import { LifeBuoy } from 'lucide-react'
import { DownloadFile } from 'v2/pages/misc/download'
import { PylonLogin } from 'v2/pages/misc/pylon-login'
import { PylonPortal } from 'v2/pages/misc/pylon-portal'
import { SupportLogin } from 'v2/pages/misc/support-login'
import { OnboardingPage } from 'v2/pages/onboarding/page'
import { AciOAuthLanding } from 'v2/pages/settings/integrations/aci-oauth-landing'
import type { IRoute } from 'v2/types'
import type { RFeatureFlags } from 'v2/types/api/auth'

export const getOtherRoutes = (meta?: { featureFlags?: RFeatureFlags }): IRoute[] => [
  {
    title: 'Onboarding',
    path: '/onboarding',
    component: <OnboardingPage />,
    hidden: true,
  },
  {
    path: '/download/:file_name',
    component: <DownloadFile />,
    title: 'Download file',
    hidden: true,
  },
  {
    title: 'Support Login',
    path: '/support/login',
    hidden: true,
    component: <SupportLogin />,
  },
  {
    title: 'Pylon Login',
    path: '/pylon/login',
    hidden: true,
    component: <PylonLogin />,
  },
  {
    // Embedded Pylon customer support portal, pinned to the bottom of the main sidebar via
    // `sidebar.pinnedToBottom` (rendered generically by app-sidebar-main, no neo coupling).
    // Visible only when BOTH: env is prod AND the `supportPortalEnabled` feature flag is on
    // (hodor-backed, off by default). When not allowed the route 404s and the bottom-pinned nav
    // item drops (getSidebarGroups filters notAllowed). The embed only authenticates on prod, so
    // it ships dark and hodor opens the gate per-org once prod is verified — no redeploy needed.
    title: 'Support',
    path: '/support/portal',
    icon: <LifeBuoy size={16} />,
    component: <PylonPortal />,
    notAllowed: process.env.REACT_APP_ENV !== 'PROD' || !meta?.featureFlags?.supportPortalEnabled,
    sidebar: { pinnedToBottom: true },
  },
  {
    title: 'Integrations OAuth Landing',
    path: '/integrations',
    hidden: true,
    component: <AciOAuthLanding />,
  },
]
